import React from 'react';
import { IClassName } from '../../../constants';

const Gitlab: React.FC<IClassName> = ({ className }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" className={className}>
      <path d="M17.5522 10.0434C17.7422 10.5731 17.7593 11.1495 17.6008 11.6895C17.4424 12.2295 17.1166 12.7053 16.6705 13.0484L11.0822 17.3517C10.7718 17.5905 10.3913 17.72 9.99968 17.72C9.6081 17.72 9.22751 17.5905 8.91718 17.3517L3.32884 13.0484C2.88272 12.7053 2.55698 12.2295 2.39854 11.6895C2.2401 11.1495 2.25713 10.5731 2.44718 10.0434L4.92884 3.1084L6.90384 8.6259C7.02884 8.9784 7.36384 9.21423 7.73801 9.21423H12.2613C12.6363 9.21423 12.9697 8.9784 13.0963 8.6259L15.0713 3.1084L17.5522 10.0434Z" stroke="currentColor" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  );
};

export default Gitlab;
